import App from './App.svelte'
import setCredentials from "./store/actions/setCredentials";
import setDevModeCredentials from "./store/actions/setDevModeCredentials";
import type {ImgRatio} from "./@types/recommendation";
import {registerHook} from "./utils/registerHook";

interface Props {
    target: HTMLElement | ShadowRoot,
    title?: string,
    maxSuggest?: number,
    imgRatio?: ImgRatio,
    layout?: string,
    productsPerPage?: number,
    productsPerMobile?: number,
    sources: string[]
    collections?: string[]
    preview?: string,
    productsIds?: string
    fixedImageSize?: string
    onHoverCarousel?: boolean
    dev?: boolean
    addToCart?: boolean
}

function createUpsellWidget({
                                target,
                                imgRatio = "1:1",
                                layout = "horizontal",
                                maxSuggest = 15,
                                title = 'You Might Also Like...',
                                productsPerPage = 5,
                                productsPerMobile = 2,
                                sources,
                                collections,
                                productsIds,
                                fixedImageSize,
                                onHoverCarousel,
                                dev,
                                addToCart = false
                            }: Props) {
    return new App({
        target,
        props: {
            imgRatio,
            layout,
            maxSuggest,
            title,
            productsPerPage,
            productsPerMobile,
            sources,
            target,
            collections,
            productsIds,
            fixedImageSize,
            onHoverCarousel,
            dev,
            addToCart
        }
    })
}

export {
    createUpsellWidget,
    setCredentials,
    registerHook,
    setDevModeCredentials,
}